import React from 'react';

const looksLikeHtml = (value: string | null | undefined): boolean =>
  Boolean(value) && /<\s*(html|body|div|p\s|p>|br|table|tr|td|a\s|a>|span|img\s|h[1-6]|ul|ol|li)/i.test(value || '');

/** Strict CSP (no external loads, no scripts) inside a sandbox="" iframe. */
const wrapBody = (body: string): string => `<!DOCTYPE html>
<html><head>
<meta charset="utf-8">
<meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'; img-src data:; font-src data:;">
<style>
  body { margin: 0; padding: 10px 12px; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif; font-size: 13px; line-height: 1.5; color: #1c1917; word-wrap: break-word; }
  img { max-width: 100%; height: auto; }
  table { max-width: 100%; }
  img[src^="http"], img[src^="//"] { display: inline-block; min-width: 12px; min-height: 12px; background: #f5f5f4; border: 1px dashed #a8a29e; }
</style>
</head><body>${body}</body></html>`;

/** Untrusted email body: HTML only ever inside a fully sandboxed iframe; plain text in a <pre>. */
export const EmailBodyView: React.FC<{ body: string; title?: string }> = ({ body, title }) =>
  looksLikeHtml(body)
    ? <iframe className="cur-body-frame" title={title || 'Email body'} sandbox="" srcDoc={wrapBody(body)} />
    : <pre className="cur-body-text">{body || 'This email has no text.'}</pre>;
